import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const profGralSpacSchema = () =>
  yup.object({
    iD_ProfileSpac: yup.number().label(i18n2._('#Perfil Spac')),
    iD_ProfGral: yup.number().label(i18n2._('#Perfil General')),
    profileSpac_Name: yup.string().label(i18n2._('Nombre del Perfil Spac')),
    profileGral_Name: yup.string().label(i18n2._('Nombre del Perfil General')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
